import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Cancel as CancelIcon, CheckCircle as CheckCircleIcon } from "@mui/icons-material";
import { green, red } from "@mui/material/colors";
import { Typography } from "@mui/material";
import { ActionsButtons } from "../../components/CustomButtons/ActionsButtons";
import { ModalV2 } from "../../components/Modal/ModalV2";
import { useToggle } from "../../hooks/useToggle";
import { useRuleValidator } from "../../hooks/useRuleValidator";
import { PERMISSIONS } from "../../router/permissions";
import { inventoryDigitalApprove } from "../../redux/actions/inventoryDigitalMovements/inventoryDigitalMovementsActions";

export const columns = [
  {
    Header: "Fecha",
    accessor: "createdAt",
    filterable: true,
    filterMethod: (filter, row) =>
      row.createdAt.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Unidad",
    accessor: "number",
    filterable: true,
    filterMethod: (filter, row) =>
      row.number.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Porcentaje actual",
    accessor: "currentPercentage",
    filterable: true,
    filterMethod: (filter, row) =>
      row.currentPercentage?.toString().toLowerCase().includes(filter.value.toLowerCase()),
    Cell: ({ value }) => (
      <span>{value} %</span>
    ),
  },
  {
    Header: "Porcentaje Requerido",
    accessor: "requestPercentage",
    filterable: true,
    filterMethod: (filter, row) =>
      row.requestPercentage?.toString().toLowerCase().includes(filter.value.toLowerCase()),
    Cell: ({ value }) => (
      <span>{value} %</span>
    ),
  },
  {
    Header: "Usuario",
    accessor: "createdBy",
    filterable: true,
    filterMethod: (filter, row) =>
      row.createdBy.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Acciones",
    filterable: true,
    Cell: ({ original }) => {
      const dispatch = useDispatch();
      const { isLoadingComp } = useSelector(({ search }) => search);
      const [openApprove, setOpenApprove] = useToggle();
      const [openReject, setOpenReject] = useToggle();

      const hasRule = useRuleValidator(PERMISSIONS.INVENTORIES_CONTROL_DIGITAL_MOVEMENTS_A_R);

      const btns = [
        {
          tooltip: "Rechazar",
          Icon: CancelIcon,
          onClick: () => setOpenReject(),
          color: 3,
          intensity: 500,
        },
        {
          tooltip: "Aprobar",
          Icon: CheckCircleIcon,
          onClick: () => setOpenApprove(),
          color: 1,
        },
      ];

      const handleSubmit = (_e) => {
        const form = {
          action: openApprove ? "AUTHORIZED" : "REJECTED",
        };
        const action = openApprove ? setOpenApprove : setOpenReject;
        dispatch(inventoryDigitalApprove(original.id, form, action));
      };

      const sx = {
        paddingRight: 1,
      };

      return (
        <>
          {original.status === "PENDING" && hasRule &&
            <ActionsButtons buttons={btns} />
          }
          {original.status === "AUTHORIZED" &&
            <Typography variant="body1" align="right" color={green[500]} sx={sx}>Aprobado</Typography>
          }
          {original.status === "REJECTED" &&
            <Typography variant="body1" align="right" color={red[500]} sx={sx}>Rechazado</Typography>
          }
          <ModalV2
            open={openApprove || openReject}
            onClose={() => openApprove && setOpenApprove() || openReject && setOpenReject()}
            title={`¿Está seguro de ${openApprove ? "aprobar" : "rechazar"} la edición?`}
            justConfirm
            onSubmit={handleSubmit}
            textSubmitBtn={openApprove ? "Aprobar" : "Rechazar"}
            colorBtn={openApprove ? "success" : "warning"}
            isLoading={isLoadingComp?.loadingInventoryDigitalMovementsActions}
          >
            <Typography variant="body1" align="center">Unidad: {original.number}</Typography>
            <Typography variant="body2" align="center">Actual: {original.currentPercentage}% | Requerido: {original.requestPercentage}%</Typography>
          </ModalV2>
        </>
      );
    },
  },
];
